module.exports = __webpack_public_path__ + "static/media/cherry-payment-processed.f3eb4177.png";